
import CpntBlocPresentationDetail from "../../components/CpntBlocPresentationDetail";
import { ContactSujetIds } from "../../config/helpers";
import img_data_expert_1 from "../../images/presentation/data_expert_1.jpg"
import "./PagePresentation.scss"


const description1 =
  <>
    <p>
      Pour <b>optimiser la gestion des données de votre fonds éditorial</b>, nous vous proposons <b>un accompagnement sur mesure</b>, alliant expertise et solutions concrètes. Nous réalisons un audit de votre fonds pour vous permettre de <b>gagner en qualité et efficacité</b>. 
    </p>
    <p>
      Notre équipe analyse en profondeur votre base de données éditoriales afin d&apos;identifier les axes d&apos;amélioration.<br/>
      Nous évaluons vos méthodes de travail, passons en revue vos processus et testons la circulation de vos données dans les circuits de diffusion. 
    </p>
</>
;

const description2 =
  <>
  <div className="mt-4">
        <p className="text-md-start text-justify">
        <u>L&apos;objectif :</u><br></br>
         Vous offrir une vision claire et détaillée de votre organisation documentaire et vous proposer des ajustements pertinents.<br/>
À l&apos;issue de cet audit, nous vous guidons dans la mise en place des corrections nécessaires.<br/>
Nous vous aidons à structurer votre catalogue de manière plus cohérente, tout en respectant la norme, en affinant les titres, l&apos;indexation et les mots-clés. 
Nous optimisons également vos processus de production et de diffusion pour assurer une transmission fluide et efficace de vos données.<br/>
<b>Avec notre accompagnement, vous gagnez en clarté, en fluidité et en performance, tout en garantissant une meilleure visibilité et accessibilité à vos ouvrages.</b>
        </p>
        <p className="text-md-start text-justify">
        <u>Comment cela fonctionne ?</u>
        <ul>
          <li>Nous faisons une étude de votre demande pour construire une proposition tarifaire</li>
          <li>Après avoir recueilli les informations, nous définissons un processus de gestion</li>
          <li>Nous procédons à l&apos;analyse des usages de la donnée et à l&apos;analyse de votre base de données</li>
          <li>Nous organisons une réunion de restitution de l&apos;analyse et des recommandations</li>
        </ul>
      </p>
    </div>
  </>
;


const PagePresentation_DataExpert = () => {

   return (
    <>
    <div className="row pt-3 pb-5">
      <div className="col col-md-10 offset-md-1 col-12 ">
        <div className="titre titre-Presentation text-center">Electre Data Expert</div>
      </div>
    </div>
        <CpntBlocPresentationDetail
          description1={description1}
        description2={description2}
          img_rond={img_data_expert_1}
          linktext="Nous contacter"
          contactsujet={ContactSujetIds.ElectreDataExpert}
        />
      </>
  );
};

export default PagePresentation_DataExpert;
